module.exports = __webpack_public_path__ + "img/tbp.60842e82.png";